import React from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { getAuthorizedClients } from '../../../graphql/queries';
import { Logger } from 'aws-amplify';

const logger = new Logger('useAuthorization');

export const useAuthorization = (token) => {
  
  const [authorization, setAuthorization] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {

    const variables = {};
    if ( token ) {
      variables['token']=token;
      API.graphql(graphqlOperation(getAuthorizedClients,variables))
        .then(res => res.data.getAuthorizedClients)
        .then(data => {
          setAuthorization(data);
          setLoading(false);
          logger.info("AUTH: ",data);
        })
        .catch(err => {
          setError(err);
          setLoading(false);
        });
    }
      
  }, [token]);
  
  return { authorization, loading, error };
};

